import React from "react";

import { useTranslation } from "react-i18next";
import { AuthingButton } from "../../../components/AuthingButton";
import { DownRcode } from "../../../components/DownRcode";
import { tryNow } from "../../../utils";
import "./styles.less";

export const IdentityBanner = (props) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="identity-banner-bg">
        <section
          className="identity-banner"
          style={{
            background: `url("//files.authing.co/authing-website/${t(
              "identify.banner.bg"
            )}")
      center center no-repeat`,
            backgroundSize: 1700,
          }}
        >
          <div className="identity-banner-container basic-column">
            <div>
              <div className="banner-title">{t("identify.banner.title")}</div>
              <div className="subtitle">{t("identify.banner.subtitle")}</div>
              <AuthingButton
                style={{ marginRight: 24, fontSize: 18 }}
                mode="dark"
                onClick={() => {
                  window.open(
                    "https://host.huiju.cool/page/2950744787608099153/43f5f5e1a2b148aa8e993c02f50e8b90"
                  );
                }}
              >
                {t("common.button.trial-request")}
              </AuthingButton>
              <AuthingButton
                style={{ marginRight: 24, fontSize: 18 }}
                mode="light"
                onClick={() => {
                  window.open(
                    "https://www.authing.cn/authingform?fromTag=身份自动化01"
                  );
                }}
              >
                {t("common.button.consult")}
              </AuthingButton>
            </div>
            {/* <div className="tenant-banner-img">
            <img
              src={`//files.authing.co/authing-website/identify-automation-banner.png`}
              alt="authing"
            />
          </div> */}
          </div>
        </section>
      </div>
      <div className="tenant-banner-data-warp">
        <div className="identity-banner-data basic-column">
          <div className="data-item">
            <div className="data-item-number">
              <span>85</span>
              <span className="data-item-character">%</span>
            </div>
            <div>{t("identify.banner.data1")}</div>
          </div>
          <div className="data-item">
            <div className="data-item-number">
              <span>79</span>
              <span className="data-item-character">%</span>
            </div>
            <div>{t("identify.banner.data2")}</div>
          </div>
          <div className="data-item">
            <div className="data-item-number">
              <span>99</span>
              <span className="data-item-character">%</span>
            </div>
            <div>{t("identify.banner.data3")}</div>
          </div>
          <div className="data-item">
            <div className="data-item-number">
              <span>93</span>
              <span className="data-item-character">%</span>
            </div>
            <div>{t("identify.banner.data4")}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
